import { getCurrentServer } from "../utils/globalData";
import config from "../config/index";
export default defineNuxtPlugin((nuxtApp) => {
    const headers = useRequestHeaders();
    const requestUrl = nuxtApp?.ssrContext?.event?.node?.req?.url || "";
    const isErpBuySite = () => {
      let resUrl=null;
      if (process.server) {
        const currentServer = getCurrentServer(headers, requestUrl);
      
        resUrl= currentServer
      }
      if(process.client){
        resUrl= window.location.href
      }
     
      return resUrl.indexOf("erp-buy-site") >= 0||config.devErpBuySite;
    }
    
    function getNowCurrentServer(){
      return getCurrentServer(headers, requestUrl);
    }
    // 提供全局访问
    return {
      provide: {
        nowCurrentServer:{
          get: getNowCurrentServer,
          value: getNowCurrentServer() // 初始值
        },
        isErpBuySite: {
          get: isErpBuySite,
          value: isErpBuySite() // 初始值
        }
      }
    }
  })
